export const ACCESS_ERROR = '/accessError';
export const LANDING = '/';
export const DASHBOARD = '/dashboard';
export const LOGIN = '/login';
export const PAGE_1 = '/inspecciones';